<!-- ----------------------------------------------- -->
<template>
  <v-card class="tm-mb-cctv-card pb-1 tm-mb-no-shadow">
    <v-row no-gutters class="align-center">
      <template v-if="hasLatestUrl">
        <v-btn
          v-if="isCurrent"
          class="tm-mb-btn-live"
          :class="{ 'btn-on': selectCamera === 'live' }"
          @click="selectCamera = 'live'"
          depressed
          >{{ text.live.label }}</v-btn
        >
        <v-btn
          v-if="!isCurrent"
          class="tm-mb-btn-live"
          :class="{ 'btn-on': selectCamera === 'live' }"
          @click="selectCamera = 'live'"
          depressed
          >{{ text.history.label }}</v-btn
        >
      </template>
      <v-btn
        v-if="hasUsualUrl"
        class="tm-mb-btn-normal"
        :class="{ 'btn-on': selectCamera === 'normal' }"
        @click="selectCamera = 'normal'"
        depressed
        >{{ text.normal.label }}</v-btn
      >
      <span class="sns-style ml-auto">
        <tm-sns v-if="!isDlg && !isReduction"></tm-sns>
      </span>
    </v-row>
    <!-- 観測設定時 -->
    <div
      v-if="selectCamera === 'live' && hasLatestUrl"
      class="tm-mb-rv-cam-title px-2"
    >
      <v-img
        v-if="isCurrent"
        :src="printCurrentPicture"
        class="tm-mb-rv-cam-now-img"
        :alt="text.live.alt"
        @error="liveImgError = true"
      >
        <template v-slot:placeholder>
          <v-sheet class="tm-mb-progress-content">
            <v-progress-circular
              v-slot:placeholder
              v-if="!liveImgError"
              indeterminate
              class="tm-mb-progress-img"
            ></v-progress-circular>
          </v-sheet>
        </template>
      </v-img>
      <v-img
        v-else
        :src="printHistoryPicture"
        class="tm-mb-rv-cam-now-img"
        :alt="text.history.alt"
      >
        <template v-slot:placeholder>
          <v-sheet class="tm-mb-progress-content">
            <v-progress-circular
              v-slot:placeholder
              indeterminate
              class="tm-mb-progress-img"
            ></v-progress-circular>
          </v-sheet>
        </template>
      </v-img>
    </div>
    <!-- 平常時 -->
    <div
      v-if="selectCamera === 'normal' && hasUsualUrl"
      class="tm-mb-rv-cam-title px-2"
    >
      <v-img
        :src="printNormallyPicture"
        class="tm-mb-rv-cam-nomal-img"
        :alt="text.normal.alt"
        @error="normalImgError = true"
      >
        <template v-slot:placeholder>
          <v-sheet class="tm-mb-progress-content">
            <v-progress-circular
              v-slot:placeholder
              v-if="!normalImgError"
              indeterminate
              class="tm-mb-progress-img"
            ></v-progress-circular>
          </v-sheet>
        </template>
      </v-img>
    </div>
    <!-- <v-btn
      class="btn-yt-mb ml-auto"
      float="tm-stg"
      text
      rounded
      v-if="!isDlg && tmSwCctv.cctvInfo.liveUrl"
      @click="openLiveUrl(tmSwCctv.cctvInfo.liveUrl)"
    >
      <span class="btn-yt-mb-text">LIVE配信はこちら</span>
      <img
        id="sns-yt-logo"
        src="/kawabou/img/sns_icons/yt_logo_rgb_light.png"
      />
    </v-btn> -->
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]危機管理 河川カメラカード
 * TmSwCctv.vue
 * @author ILUKE
 */
import mixin from "./../../lib/mixin.js";
import Util from "./../../lib/util";
import tmObs from "./../../lib/tmObs.js";
import TmSns from "./TmSns";
import PageLog from "./../../lib/pageLog.js";

export default {
  name: "tm-sw-cctv",
  mixins: [mixin],
  components: {
    TmSns,
  },
  props: {
    isDlg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      printHistoryPicture: "",
      /** 画像取得エラー */
      liveImgError: false,
      normalImgError: false,
      /** 文字列リソース */
      text: {
        // 現在(LIVE)
        live: {
          label: "現在",
          alt: "最新時画像",
        },
        // 過去
        history: {
          label: "過去",
          alt: "過去画像",
        },
        // 平常時
        normal: {
          label: "平常時",
          alt: "平常時画像",
        },
      },
    };
  },
  created() {
    if (!this.isDlg) {
      if (this.hasLatestUrl) {
        this.selectCamera = "live";
      } else {
        this.selectCamera = "normal";
      }
    }
  },
  mounted() {
    this.getPostCamera();
    /** 
     * カメラ画像表示
     * @property {boolean} this.isCurrent 観測日時 現在/過去フラグ
     * @property {string} this.$store.state.Telemeter.historyPrintCurrentPicture 過去画像の有無 
     */
    if (!this.isCurrent && !this.$store.state.Telemeter.historyPrintCurrentPicture) {
      this.getAllHistoryData();
    } else if (!this.isCurrent && this.$store.state.Telemeter.historyPrintCurrentPicture) {
      this.printHistoryPicture = this.$store.state.Telemeter.historyPrintCurrentPicture;
    }

    if (this.isCurrent) {
      this.$store.commit("sns/setPrintCurrentPicture", this.printCurrentPicture);
    }
    this.$store.commit("sns/setPrintNormallyPicture", this.printNormallyPicture);
    this.refreshImage();
  },
  computed: {
    /** 簡易版判定 */
    isReduction: {
      get() {
        return global.KWB_MODE == "reduction";
      },
    },
    /**
     * 河川カメラ情報 取得
     */
    tmSwCctv: {
      get() {
        return this.$store.state.Swin.selectedSw;
      },
    },
    hasLatestUrl: {
      get() {
        return tmObs.hasLatestUrl(this.tmSwCctv.cctvInfo);
      },
    },
    hasUsualUrl: {
      get() {
        return tmObs.hasUsualUrl(this.tmSwCctv.cctvInfo);
      },
    },
    /*
     * 提供URLで指定された画像を表示する
     * エラーが発生する場合は、画像URLで指定された画像を表示する
     */
    printCurrentPicture: {
      get() {
        const currentPicture = this.liveImgError ? this.tmSwCctv.cctvInfo.subLatestUrl : this.tmSwCctv.cctvInfo.latestUrl;
        this.$store.commit("sns/setPrintCurrentPicture", currentPicture);
        return currentPicture;
      },
    },
    printNormallyPicture: {
      get() {
        const normallyPicture = this.normalImgError ? this.tmSwCctv.cctvInfo.subUsualUrl : this.tmSwCctv.cctvInfo.usualUrl;
        this.$store.commit("sns/setPrintNormallyPicture", normallyPicture);
        return normallyPicture;
      },
    },
    /** 選択中河川カメラ画像 取得 */
    selectCamera: {
      get() {
        return this.$store.state.Telemeter.selectCamera;
      },
      set(val) {
        this.$store.commit("Telemeter/setSelectCamera", val);
      },
    },
    /**
     * 観測日時
     */
     appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    /**
     * 観測日時更新フラグ
     */
     isCurrent: {
      get() {
        return this.$store.state.app.isCurrent
      },
    },
    originProduction: {
      get() {
        return this.$store.state.app.config.originProduction;
      },
    },
    historyCamUrl: {
      get() {
        return this.$store.state.app.config.tmObsConfig.historyCamUrl;
      },
    },
    testEnvironmentsIp: {
      get() {
        return this.$store.state.app.config.testEnvironmentsIp;
      },
    }
  },
  methods: {
    getPostCamera() {
      this.$log.debug("[TmSwCctv] getPostCamera()");
      this.$store.dispatch("sns/getPostCamera", { camera: this.selectCamera });
    },
    refreshImage() {
      if (this.hasLatestUrl) {
        URL.revokeObjectURL(this.printCurrentPicture);
      }
      if (this.hasUsualUrl) {
        URL.revokeObjectURL(this.printNormallyPicture);
      }
    },
    openLiveUrl(url) {
      // アクセスログ出力
      PageLog.log({
        page_log: "mob_sns",
        obs_cd: this.$store.state.Telemeter.selectedTmParm.swobsCd,
        cam_cd: "-",
        cam_sb: "-",
        device_sb: this.$store.state.app.mode,
        sns: "yt",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });

      this.$log.debug("[TmCctv] openLiveUrl(" + url + ")");
      var win = window.open("", "_blank");
      if (url != null) {
        win.location.href = url;
      }
    },
    getSelectedObsData() {
      const appTime = new Date(this.appTime);
      const currProvUrl = this.$store.state.Swin.selectedSw.cctvInfo.latestUrl;
      const cameraId = tmObs.extractImageName(currProvUrl);
      const itmkndCd = this.$store.state.Swin.selectedSwParam.itmkndCd;
      const sysId = this.$store.state.Swin.selectedSw.cctvInfo.sysId;
      
      return {
        appTime: appTime,
        cameraId: cameraId,
        itmkndCd: itmkndCd,
        sysId: sysId,
      }
    },
    /** 過去観測時間の場合、過去画像を表示 */
    async getAllHistoryData() {
      const historyImageUrl = await tmObs.obsAppTimeArray(this.getSelectedObsData(), this.originProduction, this.historyCamUrl, this.testEnvironmentsIp);
      this.updatePrintCurrentPicture(historyImageUrl);
      this.$store.commit("Telemeter/setMovieEndTime", Util.formatDate(this.appTime));
    },
    updatePrintCurrentPicture(historyImageUrl) {
      this.printHistoryPicture = historyImageUrl;
      this.$store.commit("Telemeter/setHistoryPrintCurrentPicture", this.printHistoryPicture);
    },
  },
  watch: {
    selectCamera() {
      this.$log.debug("[TmSwCctv]watch - getPostCamera()");
      this.getPostCamera();
    },
    // カメラ情報取得 監視
    tmSwCctv() {
      if (this.hasLatestUrl) {
        this.selectCamera = "live";
      } else {
        this.selectCamera = "normal";
      }
      if (this.isCurrent) {
        this.$store.commit(
          "sns/setPrintCurrentPicture",
          this.printCurrentPicture
        );
      }
      this.$store.commit(
        "sns/setPrintNormallyPicture",
        this.printNormallyPicture
      );
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
#sns-yt-btn {
  height: 20px;
  width: 20px;
  margin-left: 10px;
  margin-right: 10px;
}
</style>
